import styled, { css } from 'styled-components';
import { BrandColor, FunctionColor, ShadeColor, SupportingColor } from '@lux/tokens';

export const ListItem = styled.li`
    position: relative;
`;

export const Button = styled.button<{
    active: boolean;
    isGRETab: boolean;
}>`
    flex: 1 0 auto;
    margin: 10px 8px 7px;
    letter-spacing: 0.03em;
    text-align: center;
    cursor: pointer;
    white-space: nowrap;
    user-select: none;
    border: none;
    background: none;
    padding: 0;

    span {
        transition: color 100ms ease-in-out;
    }

    span:hover {
        color: ${ShadeColor.dark60};
    }

    ${({ active }) => {
        return (
            active &&
            `
            border-bottom: solid 2px ${FunctionColor.function100} !important;
            margin-top: 12px;
            opacity: initial;

            span:hover {
                color: ${FunctionColor.function100};
            }
        `
        );
    }}

    ${({ isGRETab, active }) => {
        return (
            isGRETab &&
            active &&
            `
                    border-bottom: solid 2px ${SupportingColor.alert} !important;
                    span:hover {
                        color: ${SupportingColor.alert}
                    }
                `
        );
    }}
`;

export const AccessibilityButton = styled.button`
    all: unset;
    cursor: pointer;
    display: inline-block;
    position: absolute;
    right: 0;
    bottom: 8px;

    svg path {
        fill: transparent;
    }

    &:focus {
        color: revert;
        outline: revert;

        svg path {
            fill: inherit;
        }
    }

    &:focus-visible {
        outline: revert;
    }
`;
